import * as http from 'http';
import * as testimCustomToken from '../commons/testimCustomToken';
import { ArgError } from '../errors';
import type { Express } from 'express';
import type { AddressInfo } from 'net';
import type { AgentModeOptions } from '../runOptions';

export async function init({ agentPort, agentBind, project, token }: Pick<AgentModeOptions, 'agentPort' | 'agentBind' | 'project' | 'token'>) {
    const { orchestrateRoutes } = await import('./routers');
    // TODO: no need for all of this code to be inside of a Promise ctor. can simply return a never ending promise without nesting all this code
    return new Promise<void>((resolve, reject) => {
        /**
         * Init testim auth for making services request.
         */
        let initFn: (app: Express) => void = () => undefined;
        if (project) {
            testimCustomToken.init(project, token!);
            initFn = (app) => {
                app.use((req, res, next) => {
                    Object.assign(req, { project });
                    next();
                });
            };
        }

        const app = orchestrateRoutes(initFn);

        /**
         * Create HTTP server.
         */

        const server = http.createServer(app);

        /**
         * Listen on provided port, on all network interfaces.
         */
        server.listen(agentPort, agentBind);

        // logger.info('Node Version', process.version);

        server.on('error', onError);
        server.on('listening', onListening);

        /**
         * Event listener for HTTP server "error" event.
         */

        function onError(error: Error & { syscall?: string; code?: string }) {
            if (error.syscall !== 'listen') {
                return reject(error);
            }

            // handle specific listen errors with friendly messages
            switch (error.code) {
                case 'EACCES':
                case 'EPERM':
                    return reject(new ArgError(`Port ${agentPort} requires elevated privileges`));
                case 'EADDRINUSE':
                    return reject(new ArgError(`Port ${agentPort} is already in use, is another Testim instance running?`));
                default:
                    return reject(error);
            }
        }

        /**
         * Event listener for HTTP server "listening" event.
         */

        function onListening() {
            const { port } = server.address() as AddressInfo;
            // eslint-disable-next-line no-console
            console.log(`Running on port: ${port}`);
            showStartStopOptions();
        }
    });
}

async function showStartStopOptions() {
    const prompts = require('prompts') as typeof import('prompts');
    const sigint = 'Ctrl + C';
    await prompts({
        name: '',
        type: 'text',
        message: `Type the word "stop" or Press ${sigint}.`,
        validate: x => x.toUpperCase().trim() === 'STOP',
    });
    // eslint-disable-next-line no-console
    console.log('Exiting Testim CLI');
    process.exit(0);
}
